import { appUpdater } from "../pwa/register";

/** The shared document was written by a newer schema than this build understands. */
export function ReadOnlyBanner({ canWrite }: { canWrite: boolean }) {
  if (canWrite) return null;
  return (
    <div className="banner banner-warning" role="alert">
      <span>
        This document was saved by a newer version of codescreen. It's read-only until you update.
      </span>
      <button
        type="button"
        onClick={() => void appUpdater.checkForUpdate().then(() => appUpdater.applyUpdate())}
      >
        Refresh to update
      </button>
    </div>
  );
}
